export default {
  "en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anglaise"])},
  "fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Français"])},
  "routerErrorTitile": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez rafraîchir votre navigateur"])},
  "routerErrorSubtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous utilisez une ancienne version de Snapshot qui n'est plus disponible. Veuillez rafraîchir votre navigateur"])}
}